import React from "react";
import classNames from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import { renderMarkdownHtml } from "./renderMarkdownHtml";
import s from "./styles.scss";

interface Props {
  content: string;
  className?: string;
}

function MarkdownContent({ content, className }: Props) {
  if (!content) {
    return null;
  }

  const html = renderMarkdownHtml(content);

  return (
    <div
      className={classNames(s.root, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default withStyles(s)(MarkdownContent);
